const { encrypt } = require('@/plugins/crypto')

export default function ({ route, store, redirect }) {
  const id = route.params['id']

  localStorage.setItem('device_id', encrypt(id))
  setTimeout(() => {
    return redirect('/id.reg/device/form')
  }, 100)
}
